export default __webpack_public_path__ + "static/media/cabbage.c5424c1c.png";